exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".icrs-unauthorized-page-header{width:100%;padding:1rem 0}.icrs-unauthorized-page-body{margin-top:10rem}", ""]);

// exports
